export const LOGIN_URL = 'https://app.rewayz.com'

export const DEMO_URL =
  'https://meetings-eu1.hubspot.com/yassin-korchi?embed=true&uuid=15e23d5e-72f4-4c1f-9e3f-891d848dd2d0'
